import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext as NavigateNextIcon, Home as HomeIcon } from '@mui/icons-material';
import { useAppSelector } from '@/store';

export const Breadcrumbs: React.FC = () => {
  const breadcrumbs = useAppSelector((state) => state.ui.breadcrumbs);

  if (breadcrumbs.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link
          component={RouterLink}
          to="/"
          color="inherit"
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <HomeIcon sx={{ fontSize: '1rem' }} />
        </Link>
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          if (isLast || !crumb.path) {
            return (
              <Typography key={index} color="text.primary" variant="body2" fontWeight={500}>
                {crumb.label}
              </Typography>
            );
          }
          return (
            <Link
              key={index}
              component={RouterLink}
              to={crumb.path}
              color="inherit"
              underline="hover"
              variant="body2"
            >
              {crumb.label}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};
